import React from "react"
import PropTypes from "prop-types"
import { Navigate, useParams } from "react-router-dom"
import { isFeatureEnabled } from "config/features"
import { routes } from "router"

// booking-widget.js and the hosted /book page open the old #/embedded/ list and detail URLs.
// While NEW_BOOKING_WIDGET is on, those two entry points hand over to the new widget; otherwise the
// old screen renders as before. Keeping the embed URLs unchanged means an older cached app bundle
// can never be asked for a route it doesn't have.
const NewWidgetRedirect = ({ children }) => {
  const { uuid, id } = useParams()

  if (!isFeatureEnabled("NEW_BOOKING_WIDGET")) return children

  return <Navigate to={id ? routes.widgetExperience({ uuid, id }) : routes.widgetListing({ uuid })} replace />
}

NewWidgetRedirect.propTypes = {
  children: PropTypes.node.isRequired
}

export default NewWidgetRedirect
